import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import Dashboard from './pages/Dashboard';
import ComprobanteForm from './pages/ComprobanteForm';
import ComprobantesList from './pages/ComprobantesList';
import ReporteIVA from './pages/ReporteIVA';
import ArchiveHistory from './pages/ArchiveHistory';
import ImportCSV from './pages/ImportCSV';
import TimbradoManager from './pages/TimbradoManager';
import EditComprobanteForm from './pages/EditComprobanteForm';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import authService from './services/auth';

function NavBar() {
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <i className="bi bi-receipt"></i> Sistema de Comprobantes SET
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                <i className="bi bi-house"></i> Inicio
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/comprobantes/new">
                <i className="bi bi-plus-circle"></i> Nuevo Comprobante
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/comprobantes">
                <i className="bi bi-list"></i> Listado
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/reportes/iva">
                <i className="bi bi-bar-chart"></i> Reporte IVA
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/timbrados">
                <i className="bi bi-stamp"></i> Timbrados
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/archives">
                <i className="bi bi-clock-history"></i> Historial
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/import">
                <i className="bi bi-upload"></i> Importar
              </Link>
            </li>
            <li className="nav-item">
              <button 
                className="nav-link btn btn-link" 
                onClick={handleLogout}
                style={{ border: 'none', background: 'none', cursor: 'pointer' }}
              >
                <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <NavBar />

        {/* Main Content */}
        <div className="container main-container mt-4">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/comprobantes/new" element={<PrivateRoute><ComprobanteForm /></PrivateRoute>} />
            <Route path="/comprobantes" element={<PrivateRoute><ComprobantesList /></PrivateRoute>} />
            <Route path="/reportes/iva" element={<PrivateRoute><ReporteIVA /></PrivateRoute>} />
            <Route path="/comprobantes/:id/edit" element={<PrivateRoute><EditComprobanteForm /></PrivateRoute>} />
            <Route path="/timbrados" element={<PrivateRoute><TimbradoManager /></PrivateRoute>} />
            <Route path="/archives" element={<PrivateRoute><ArchiveHistory /></PrivateRoute>} />
            <Route path="/import" element={<PrivateRoute><ImportCSV /></PrivateRoute>} />
          </Routes>
        </div>

        {/* Toast Notifications */}
        <ToastContainer position="top-right" autoClose={5000} />
      </div>
    </Router>
  );
}

export default App;
